import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Ptag } from "../../../components/fonts";
import { colors } from "../../../theme";
import { Divider } from "@mui/material";
import { insurers } from "../../../components/memberApp/constants/PolicyConstants";
import { Image } from "../../../components/business/CdBalance/style";
import { formatToRupees } from "../../../utils/utils";
import LargeButton from "../../../components/LargeButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function BufferCard({ details }) {
  const history = useHistory();
  const [insurer, setInsurer] = useState();
  const initialValues = useMemo(() => {
    const product_dtails = JSON.parse(localStorage.getItem("gmc_details"));
    let boolean_value = Object.keys(product_dtails).includes(
      "health_insurance"
    );
    if (boolean_value) {
      let logo = product_dtails["health_insurance"].service_provider_logo;
      setInsurer(logo);
    }
  }, [details]);
  const redirectToUpdatePage = () => {
    history.push("/business/view-buffer-table", { details });
  };
  return (
    <>
      <Box>
        <FlexRow
          style={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="20px">
              Group Mediclaim Cover
            </Ptag>
            <Ptag fontWeight="500" fontSize="14px" color="#7D7C7C">
              Last updated on {details && details.last_updated_date}
            </Ptag>
          </FlexColumn>
          <Image src={insurer} style={{ marginTop: "0", maxWidth: '7rem', maxHeight: '3rem', objectFit: 'contain' }} />
        </FlexRow>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="14px" color={colors.neoBlueFont}>
              Amount Allotted
            </Ptag>
            <Ptag fontWeight="700" fontSize="20px">
              {details && details.amount_alloted
                ? formatToRupees(details.amount_alloted.toString())
                : "₹0"}
            </Ptag>
          </FlexColumn>
          <FlexColumn style={{ gap: "0.5rem" }}>
            <Ptag fontWeight="500" fontSize="14px" color={colors.neoBlueFont}>
              Amount Utilized
            </Ptag>
            <Ptag fontWeight="700" fontSize="20px">
              {details && details.amount_utilised
                ? formatToRupees(details.amount_utilised.toString())
                : "₹0"}
            </Ptag>
          </FlexColumn>
        </FlexRow>
        <FlexColumn style={{ gap: "0.5rem" }}>
          <Ptag fontWeight="500" fontSize="14px" color={colors.neoBlueFont}>
            Remaining Balance
          </Ptag>
          <Ptag fontWeight="700" fontSize="20px">
            {details && details.remaining_balance
              ? formatToRupees(details.remaining_balance.toString())
              : "₹0"}
          </Ptag>
        </FlexColumn>
        <Divider sx={{}} />
        <LargeButton
          onClick={() => redirectToUpdatePage()}
          label={"View Utilisation"}
          style={{ marginTop: "0px" }}
          bgColor={"#231A3D"}
          disabled={details && details.history_data.length === 0}
          opacity={details && details.history_data.length === 0 && "50%"}
        />
      </Box>
    </>
  );
}

export default BufferCard;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  height: 32rem;
  width: 46rem;
  border: 1px solid #231a3d;
  border-radius: 10px;
  padding: 2rem;
  gap: 2rem;
  background-color: #e5f7ff4d;
`;

export const FlexRow = styled.div`
  display: flex;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
